import { Box, Grid } from "@mui/material";
import "../../assets/styles/pages/Fleet/driverPage.css";
import CompanyTable from "../../components/Fleet/CompanyTable/CompanyTable";
import CompanyPopup from "../../components/Fleet/CompanyPopup/CompanyPopup";

const CompanyPage = () => {
  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <CompanyPopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CompanyTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CompanyPage;
